import { serializeError } from 'serialize-error';

export const serializeContext = (value: unknown, depth = 0): unknown => {
  if (depth > 4) {
    return '[max depth]';
  }
  if (value instanceof Error) {
    return serializeError(value);
  }
  if (Array.isArray(value)) {
    return value.map(v => serializeContext(v, depth + 1));
  }
  if (value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([k, v]) => [k, serializeContext(v, depth + 1)]),
    );
  }
  return value;
};
